import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {useState, MouseEvent} from "react";
import { jdlButtonProps } from "../../../../utils/types";
import { ADD_CLIENT_END_POINT } from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";

const AddClientButton : React.FC<jdlButtonProps> = ({inputName, onSubmit, onClear}) =>{
    const [loading, setLoading] = useState<boolean>(false);

    function saveClient (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(inputName === '') return onSubmit({success: false, message : 'Please insert client name.'})
        setLoading(true);

        setTimeout(async()=>{
            try{
                await api.post(ADD_CLIENT_END_POINT, {client_name : inputName}, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                onSubmit({
                    success: true, 
                    message : 'New client added!'
                })
                setLoading(false);
                onClear();
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    onSubmit({
                        success: false, 
                        message : 'Unauthorized access!'
                    })
                }else{
                    onSubmit({
                        success: false, 
                        message : 'An error occured!'
                    })
                }
                setLoading(false)
            }
        },500);
    }

    return (
        <div className="input-container">
            {loading ? (
                <button type="button" disabled className='button button-disabled'>
                    <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                </button>
            ) : (
                <button type="button" onClick={saveClient} className="button button-vcc-primary text-md">
                    Add Client
                </button>
            )}
        </div>
    );
}

export default AddClientButton;